// removed by extract-text-webpack-plugin
module.exports = {"full-height":"-RK60Zvbdwp9BVKDl1vyG","row":"_1Gou1XKGwlPtjvxzwLkdSa","title":"_6SNV-sG6WEFpdeWhnDEUU","custom-card-booking-review-right":"sJO2uLwfoLoB9piEPORKy","ant-card":"_2AKZ2J3EosHqnP2BfUMd6T","footer":"_2jR4PAzv9KdX0V6m1SjA6_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/Include/rebook_form_date_time.css
// module id = 3012
// module chunks = 0